import { useMutation } from 'glimmer-apollo'
import { parse } from 'graphql'
import type { CreateOrdersFromQuotesInput, CreateOrdersFromQuotesResponse } from 'create-orders-from-quotes'

export function createOrdersFromQuotes(
  context: Object,
  variables: CreateOrdersFromQuotesInput
): Promise<CreateOrdersFromQuotesResponse | undefined | null> {
  return new Promise((resolve, reject) => {
    const createOrdersFromQuotesMutation = useMutation<CreateOrdersFromQuotesResponse, CreateOrdersFromQuotesInput>(context, () => [
      mutation,
      {
        onError: (error) => {
          reject(new Error('Failed to create orders from quotes.', { cause: error }))
        },
        onComplete: (data: CreateOrdersFromQuotesResponse | undefined | null) => {
          resolve(data)
        }
      }
    ])

    createOrdersFromQuotesMutation.mutate(variables)
  })
}

const mutation = parse(`
  mutation CreateOrdersFromQuotes($input: CreateOrdersFromQuotesInput!) {
    createOrdersFromQuotes(input: $input) {
      errors {
        code
        detail
        value
      }
      requiresAction {
        ... on StripeClientAuthentication {
          clientSecret
        }
        ... on CardIssuerDiscountIneligible {
          cardIssuerDiscountAmount {
            amount
            formatted
            currency
          }
        }
      }
      orders {
        id
        sales {
          __typename
          ... on Booking {
            idWithSecret
            reservationStatus
            bookingPortalUrl
            activitySnapshot {
              name
            }
          }
        }
        currency
        displayId
        balance {
          total {
            amount
            currency
          }
        }
      }
    }
  }
`)

export default mutation
